<template>
  <el-drawer
    size="85%"
    :title="$t('auditDetail.title')"
    append-to-body
    :visible="changeVisiable"
    direction="rtl"
    :close-on-press-escape="true"
    :wrapperClosable="false"
    @close="close">
    <div
      v-loading="infoDetailLoading"
      :element-loading-text="$t('auditDetail.loadingText')"
      element-loading-spinner="el-icon-loading">
      <div class="audit-info">
        <div class="info-top row align-center">
          <div class="info-line"></div>
          <div class="info-title">
            {{reviewInfo.queryFlowType === '3' ? $t('auditDetail.priceChangeApply') : reviewInfo.queryFlowType === '5' ? $t('auditDetail.badGoodsApply') : reviewInfo.queryFlowType === '6' ? $t('auditDetail.voidApply') : ''
            }}
          </div>
        </div>
        <div class="info-list">
          <img
            class="info-img"
            v-if="infoList.state || infoList.state === '0'"
            :src="reviewInfo.queryFlowType === '6' ? voidState[infoList.state] : invoiceState[infoList.state]" />
          <el-row>
            <el-col :span="8">
              <div class="row align-center">
                <div class="list-label">{{$t('auditDetail.submitter')}}</div>
                <div class="list-value">{{ infoList.submitUserName }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="row align-center">
                <div class="list-label">{{$t('auditDetail.submitTime')}}</div>
                <div class="list-value">{{ infoList.createTime }}</div>
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="row align-center">
                <div class="list-label">审批编号</div>
                <div class="list-value">{{ infoList.reviewNo }}</div>
              </div>
            </el-col> -->
            <el-col :span="8">
              <div class="row align-center">
                <div class="list-label">{{$t('auditDetail.shopName')}}</div>
                <div class="list-value">{{ infoList.deptName }}</div>
              </div>
            </el-col>
            <template v-if="reviewInfo.queryFlowType === '3'">
              <el-col :span="8">
                <div class="row align-center">
                  <div class="list-label">{{$t('auditDetail.originalPrice')}}</div>
                  <div class="list-value">{{ infoList.beforePrice }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="row align-center">
                  <div class="list-label">{{$t('auditDetail.afterPrice')}}</div>
                  <div class="list-value">{{ infoList.afterPrice }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="row align-center">
                  <div class="list-label">{{$t('auditDetail.priceChange')}}</div>
                  <div class="list-value">{{moneyPrice()}}</div>
                </div>
              </el-col>
              <!-- <el-col :span="8">
                <div class="row align-center">
                  <div class="list-label">低于原价(%)</div>
                  <div class="list-value">{{ infoList.lessThanPercent }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="row align-center">
                  <div class="list-label">低于原价(元)</div>
                  <div class="list-value">{{ infoList.lessThanPrice }}</div>
                </div>
              </el-col> -->
            </template>
          </el-row>
          <el-row>
            <el-col>
              <div class="row align-center">
                <div class="list-label">{{$t('auditDetail.remark')}}</div>
                <div class="list-value">{{ infoList.description }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <template v-if="infoList.couponInfoList && infoList.couponInfoList[0]">
        <div style="height: 10px; background: #f5f5f5; margin: 0"></div>
        <div style="padding: 20px 0;">
          <div class="row align-center">
            <div class="info-line"></div>
            <div class="info-title">{{$t('auditDetail.couponInfo')}}</div>
          </div>
          <div v-for="(item, i) in infoList.couponInfoList" :key="i" style="padding: 10px;border-radius: 6px;background: rgb(245,247,250);margin-top: 15px;width: 800px;margin-left: 20px;">
            <div class="row align-center" style="font-size: 14px;color: #666;">
              <span class="row align-center">
                {{$t('auditDetail.couponInfoSource')}}：
                <img v-if="item.channel === '1'" src="@/assets/images/douyin.png" style="width: 14px;margin-right: 5px;border-radius: 4px;" />
                <img v-if="item.channel === '2'" src="@/assets/images/kuaishou.png" style="width: 14px;margin-right: 5px;border-radius: 4px;" />
                <img v-if="item.channel === '3'" src="@/assets/images/wxchat.png" style="width: 14px;margin-right: 5px;border-radius: 4px;" />
                {{item.channelName}}
              </span>
              <span style="margin-left: 50px;">{{$t('auditDetail.couponInfoType')}}：{{item.type}}</span>
            </div>
            <div style="font-size: 16px;font-weight: bold;color: #000;margin: 10px 0;">{{item.title}}</div>
            <div style="color: #999;font-size: 14px;">{{$t('auditDetail.validityPeriod')}}：{{item.startTime}}{{$t('auditDetail.to')}}{{item.expireTime}}</div>
          </div>
        </div>
      </template>
      <div style="height: 10px; background: #f5f5f5; margin: 0"></div>
      <div class="table-card">
        <div class="row align-center">
          <div class="info-line"></div>
          <div class="info-title">
            {{reviewInfo.queryFlowType === '3' ? $t('auditDetail.changeGoodsList') : reviewInfo.queryFlowType === '5' ? $t('auditDetail.badGoodsList') : reviewInfo.queryFlowType === '6' ? $t('auditDetail.voidList') : ''}}
          </div>
          <div v-if="reviewInfo.queryFlowType === '3'" style="margin-left: 100px;color:red;">
            <span style="margin-right: 40px;">{{$t('auditDetail.changeBefore')}}：{{infoList.beforePrice}}</span>
            <span>{{$t('auditDetail.changeAfter')}}：{{infoList.afterPrice}}</span>
          </div>
        </div>
        <section style="margin: 20px 16px 0 25px">
          <grid-manager
            v-if="tableData.length"
            :option="
              reviewInfo.queryFlowType === '3'
                ? changePriceOption
                : reviewInfo.queryFlowType === '5'
                ? cipinOption
                : reviewInfo.queryFlowType === '6'
                ? voidOptions
                : otherOptions
            "></grid-manager>
        </section>
      </div>
      <div style="height: 10px; background: #f5f5f5; margin: 0"></div>
      <section>
        <FlowDetail
          v-if="infoList.instanceFlowListResp"
          :instanceFlowListResp="infoList.instanceFlowListResp"></FlowDetail>
      </section>
    </div>
  </el-drawer>
</template>

<script>
import FlowDetail from '@/components/FlowDetail.vue'
import { queryInvoicesInfoOms } from '@/libs/http/api.js'
import { posQueryAlterPriceInfo, postQueryVoidInfo } from '@/libs/http/modules/posOrder'
export default {
  props: ['reviewInfo'],
  components: {
    FlowDetail
  },
  data() {
    return {
      changeVisiable: true,
      invoiceState: {
        '-1': require('@/assets/images/state/ReviewDetails_0.png'),
        3: require('@/assets/images/state/ReviewDetails_1.png'),
        0: require('@/assets/images/state/ReviewDetails_1.png'),
        1: require('@/assets/images/state/ReviewDetails_2.png'),
        2: require('@/assets/images/state/ReviewDetails_3.png'),
        4: require('@/assets/images/state/ReviewDetails_4.png')
      },
      voidState: {
        1: require('@/assets/images/state/ReviewDetails_1.png'),
        2: require('@/assets/images/state/ReviewDetails_2.png'),
        3: require('@/assets/images/state/ReviewDetails_3.png'),
        4: require('@/assets/images/state/ReviewDetails_0.png')
      },
      changePriceOption: {
        gridManagerName: 'changePrice',
        firstLoading: true,
        height: '275px',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: 'goodsImg',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '350px',
            template: () => {
              return `
                <div class="row align-center" style="text-align:left;">
                  <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div class="row align-center space-center" v-else style="width:102px;height:92px;border-radius:4px;text-align:center;color:#999;background:#f5f5f5;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
                  </div>
                  <div class="column space-center" style="margin-left:10px;flex:1;">
                    <div style="font-size:18px;color:#333;margin-top:-4px;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                  </div>
                </div>
              `
            }
          },
          {
            key: 'attr',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            // width: "180px",
            template: () => {
              return `
                <div v-if="row.attrList" class="row space-center align-center" style="width:130px;border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;margin:0 auto">
                  <p v-for="(item, index) in row.attrList.slice(0, 2)" :key="item.code" style="margin-right:10px;">{{item.value}}
                   <span v-if="index == 0" style="margin:0 3px;">,</span>
                  </p>
                </div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px">
                  {{row.tagPrice}}đ
                </div>
              `
            }
          },
          {
            key: 'discount',
            text: this.$t('gridManage.discount'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px">
                  {{(row.unitAfterRealPrice / row.tagPrice * 10).toFixed(1)}}%
                </div>
              `
            }
          },
          {
            key: 'number',
            text: this.$t('gridManage.number'),
            align: 'center',
            // width: "120px",
            template: () => {
              return `
                  <div class="row align-center space-center" style="font-size:18px">
                    {{row.number}}
                  </div>
                `
            }
          },
          {
            key: 'oldPrice',
            text: this.$t('gridManage.originalPrice'),
            align: 'center',
            // width: "120px",
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px;">
                  {{row.oldPrice}}đ
                </div>
              `
            }
          },
          {
            key: 'unitRealPrice',
            text: this.$t('gridManage.agoRealPrice'),
            align: 'center',
            // width: "120px",
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px;">
                  {{row.unitRealPrice}}đ
                </div>
              `
            }
          },
          {
            key: 'unitAfterRealPrice',
            text: this.$t('gridManage.realPrice'),
            align: 'center',
            width: '130px',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px;">
                  <div v-if="row.isNotAll" class="row align-center space-center"> 
                    <input disabled v-model="row.unitAfterRealPrice" style="border:1px solid #eee;outline:none;background:#FAFAFA;width:90px;text-align:center;height:46px;font-size:20px;border-radius:2px;" />
                    <span style="color:#666;margin-right:8px;">đ</span>
                  </div>
                  <p v-else class="row align-center space-center"> 
                    <span style="border:1px solid #eee;background:#FAFAFA;width:90px;line-height:46px;">{{row.unitAfterRealPrice}}</span>
                    <span>đ</span>
                  </p>
                </div>
              `
            }
          },
          {
            key: 'totalRealPrice',
            text: this.$t('gridManage.beforeTotalPrice'),
            align: 'center',
            // width: "130px",
            template: () => {
              return `
                <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                  {{(row.unitRealPrice * row.number).toFixed(2)}}đ
                </div>
              `
            }
          },
          {
            key: 'allUnitAfterRealPrice',
            text: this.$t('gridManage.afterTotalPrice'),
            align: 'center',
            // width: "130px",
            template: () => {
              return `
                <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                  {{(row.unitAfterRealPrice * row.number).toFixed(2)}}đ
                </div>
              `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
      cipinOption: {
        gridManagerName: 'cipinlist',
        firstLoading: true,
        height: 'auto',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportMenu: false,
        supportConfig: true,
        disableAutoLoading: true,
        disableBorder: false,
        disableLine: false,
        columnData: [
          {
            key: 'barCode',
            text: this.$t('gridManage.goodsBarCode'),
            align: 'center'
          },
          {
            key: 'goodsNo',
            text: this.$t('gridManage.goodsNo'),
            align: 'center'
          },
          {
            key: 'goodsName',
            text: this.$t('gridManage.goodsName'),
            align: 'center'
          },
          {
            key: 'number',
            text: this.$t('gridManage.number'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <input v-if="row.isApprove" :placeholder="row.number || '0'" v-model="row.number" style="border:1px solid #ddd;line-height:30px;width:100px;outline:none;text-align:center;color:#666;" @focus="getDefaultVal(row.number)" @change="setNewNumber(row, index)" />
                  <span v-else>{{row.number}}</span>
                </div>
              `
            }
          },
          {
            key: 'suggestPrice',
            text: this.$t('gridManage.suggestPrice'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <input v-if="row.isApprove" :placeholder="row.suggestPrice || '0.00'" v-model="row.suggestPrice" style="border:1px solid #ddd;line-height:30px;width:100px;outline:none;text-align:center;color:#666;" @focus="getDefaultVal(row.suggestPrice)" @change="setNewPrice(row, index)" />
                  <span v-else>{{row.suggestPrice}}</span>
                </div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            align: 'center'
          },
          {
            key: 'goodsImages',
            text: this.$t('gridManage.goodsImages'),
            align: 'center',
            template: () => {
              return `
                <div>
                  <el-image v-if="row.goodsImages && row.goodsImages.length" src="http://soko.upload.babiboy.com/group1/M00/29/58/Cs4ABWMJzF6AGDc5AAACnSHXppY109.png" style="width: 42px;height: 12px;" :preview-src-list="row.goodsImages"></el-image>
                  <span v-else>{{$t('gridManage.notUploadImg')}}</span>
                </div>
              `
            }
          },
          {
            key: 'tagImages',
            text: this.$t('gridManage.tagImages'),
            align: 'center',
            template: () => {
              return `
                <div>
                  <el-image v-if="row.tagImages && row.tagImages.length" src="http://soko.upload.babiboy.com/group1/M00/29/58/Cs4ABWMJzF6AGDc5AAACnSHXppY109.png" style="width: 42px;height: 12px;" :preview-src-list="row.tagImages"></el-image>
                  <span v-else>{{$t('gridManage.notUploadImg')}}</span>
                </div>
              `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
      voidOptions: {
        gridManagerName: 'voidList',
        firstLoading: true,
        height: '275px',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportMenu: false,
        supportConfig: true,
        disableAutoLoading: true,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: 'goodsName',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '310px',
            template: () => {
              return `
                <div class="row align-center" style="text-align:left;">
                  <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div v-else style="width:102px;height:92px;border-radius:4px;text-align:center;line-height:92px;color:#999;background:#f5f5f5;">暂无图片{{$t('gridManage.columnGoodsInfo')}}</div>
                    <div v-if="row.activeId"
                      style="
                      width:70px;height:22px;line-height:22px;position:absolute;top:4px;right:-19px;transform: rotate(45deg);text-align:center;
                      background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400);color:#fff;font-size:12px;">
                      {{$t('gridManage.columnGoodsInfo')}}
                    </div>
                  </div>
                  <div class="column space-center" style="margin-left:10px;flex:1;">
                    <div style="font-size:18px;color:#333;margin-top:-4px;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;">{{$t('gridManage.columnGoodsInfo')}}：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.columnGoodsInfo')}}：{{row.barCode}}</div>
                  </div>
                </div>
              `
            }
          },
          {
            key: 'colorDesc',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            // width: "150px",
            template: () => {
              return `
              <div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
                <p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
                  <span v-if="index == 0" style="margin:0 3px;">,</span>
                </p>
              </div>
            `
            }
          },
          {
            key: 'unitRealPrice',
            text: this.$t('gridManage.realPriceUnit'),
            align: 'center',
            // width: "200px",
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span style="color:#666;font-size:20px;">{{row.unitRealPrice}}đ</span>
                </div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span style="font-size:20px;">{{row.tagPrice}}đ</span>
                </div>
              `
            }
          },
          {
            key: 'totalRealPrice',
            text: this.$t('gridManage.totalPrice'),
            align: 'center',
            // width: "150px",
            template: () => {
              return `
                        <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                        {{row.totalRealPrice}}đ
                        </div>
                    `
            }
          },
          {
            key: 'number',
            text: this.$t('gridManage.sellNumber'),
            align: 'center',
            // width: "100px",
            template: () => {
              return `
                      <div class="row align-center space-center" style="color:#333333;font-size:20px;">
                        {{row.number || 0}}
                        </div>
                    `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
      otherOptions: {
        gridManagerName: 'otherList'
      },
      tableData: [],
      infoList: {},
      infoDetailLoading: false
    }
  },
  created() {
    if (this.reviewInfo.queryFlowType === '3') {
      this.fetchPrice()
    } else if (this.reviewInfo.queryFlowType === '6') {
      this.fetchVoid()
    } else {
      this.queryInvoicesInfo()
    }
  },
  methods: {
    fetchPrice() {
      this.infoDetailLoading = true
      posQueryAlterPriceInfo({
        id: this.reviewInfo.id
      })
        .then(data => {
          this.infoList = data
          this.tableData = data.goodsInfos || []
          this.infoDetailLoading = false
          GridManager.refreshGrid(this.changePriceOption.gridManagerName)
        })
        .catch(error => {
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
          this.infoDetailLoading = false
        })
    },
    fetchVoid() {
      this.infoDetailLoading = true
      postQueryVoidInfo({
        id: this.reviewInfo.id
      })
        .then(data => {
          this.infoList = data
          this.tableData = data.goodsInfos || []
          this.infoDetailLoading = false
          GridManager.refreshGrid(this.voidOptions.gridManagerName)
        })
        .catch(error => {
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
          this.infoDetailLoading = false
        })
    },

    queryInvoicesInfo() {
      this.infoDetailLoading = true
      let reqData = {
        reviewId: this.reviewInfo.id,
        hrFlowTypeId: this.reviewInfo.hrFlowTypeId,
        instanceInfoId: this.reviewInfo.instanceInfoId
      }
      queryInvoicesInfoOms(reqData)
        .then(data => {
          this.infoList = data
          this.tableData = data.goodsInfos || []
          if (data.reviewType === '5') {
            this.reviewInfo.queryFlowType = '5'
            let list = [
              {
                barCode: data.barCode,
                goodsNo: data.goodsNo,
                goodsName: data.goodsName,
                number: data.number,
                tagPrice: data.tagPrice,
                suggestPrice: data.suggestPrice,
                goodsImages: data.goodsImages ? data.goodsImages.split(',') : [],
                tagImages: data.tagImages ? data.tagImages.split(',') : []
              }
            ]
            this.tableData = list
            GridManager.refreshGrid(this.cipinOption.gridManagerName)
          } else {
          }
          setTimeout(() => {
            this.infoDetailLoading = false
          }, 500)
        })
        .catch(err => {
          this.$message({ showClose: true, message: err, type: 'error', duration: 2000 })
          this.infoDetailLoading = false
        })
    },
    moneyPrice(){
      // console.log(Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice))
      if(Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice) < 0){
        return this.$t('changePrice.addPrice', {money: ((Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice)) * -1).toFixed(2)})
        // return `增加${((Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice)) * -1).toFixed(2)}`
      }else{
        return this.$t('changePrice.miniPrice', {money: (Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice)).toFixed(2)})
        // return `减少${(Number(this.infoList.beforePrice) - Number(this.infoList.afterPrice)).toFixed(2)}`
      }
    },

    showGoodsTable() {
      if (this.tableData.length) {
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.tableData
          }
          resolve(tableData)
        })
      }
    },
    close() {
      this.changeVisiable = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-card {
  padding: 20px 0;
}
.mar-top {
  margin-top: 5px;
}
.info-line {
  width: 4px;
  height: 24px;
  background: #067cf2;
  margin-right: 20px;
}
.info-title {
  font-size: 18px;
  color: #333333;
}
.audit-info {
  padding: 0 0 25px;
  .info-list {
    padding: 10px 25px 0;
    position: relative;
    .info-img {
      position: absolute;
      width: 84px;
      height: 74px;
      right: 109px;
      top: -15px;
      z-index: 9;
    }
    .list-label {
      color: #999;
      text-align: left;
      margin: 0 10px 10px 0;
    }
    .list-value {
      color: #333;
      margin-bottom: 10px;
    }
  }
}
</style>
